<template>
  <button
    class="u-button"
    :class="[type, { 'is-loading': loading }]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span class="loader-container">
      <span class="loader"></span>
    </span>
    <slot />
  </button>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'primary',
        validator: val => ['primary', 'secondary'].includes(val)
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>

  .u-button {
    position: relative;
    font-weight: 700;
    text-align: center;
    line-height: 1.5;
    background: transparent;
    border: 0;
    box-shadow: 0;
    padding: .75rem 1.5rem;
    min-width: 7.5rem;
    border-radius: var(--ec-button-border-radius, var(--ec-border-radius, 3px));
    outline: none;
    cursor: pointer;
    transition: .25s ease-out;

    &.is-loading {
      padding-left: 4em;
      .loader-container {
        visibility: visible;
        opacity: 1;
      }
    }

  }

  .primary {
    background-color: var(--ec-primary-color, black);
    color: white;

    &:hover {
      background-color: var(--ec-primary-color-darker, black);
    }

  }

  .secondary {
    color: var(--ec-primary-color, black);
    box-shadow: inset 0 0 0 1px currentColor;

    &:hover {
      color: var(--ec-primary-color-darker, black);
    }

  }

  .loader-container {
    position: absolute;
    top: 50%;
    left: 1.5em;
    width: 1.5em;
    height: 1.5em;
    margin-top: -.75em;
    visibility: hidden;
    opacity: 0;
  }

  .loader {
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border-top: 2px solid rgba(white, 0.2);
    border-right: 2px solid rgba(white, 0.2);
    border-bottom: 2px solid rgba(white, 0.2);
    border-left: 2px solid white;
    transform: translateZ(0);
    animation: load 1.1s infinite linear;
  }

  @keyframes load {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

</style>